function animateWord(wordClass = '.growtype-text-animation') {
    const textAnimItems = document.querySelectorAll(wordClass);
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const transformY = '110';

    function getWordWidth(word, fontSize, fontFamily) {
        context.font = fontSize + ' ' + fontFamily;
        return context.measureText(word).width;
    }

    function populateText() {
        textAnimItems.forEach(item => {
            if (item.dataset.animationRunning === 'true') {
                return;
            }
            const dataWords = item.getAttribute('data-words');
            if (!dataWords) {
                return;
            }
            const words = dataWords.split('|');
            const computedStyles = getComputedStyle(item);
            const fontSize = computedStyles.fontSize;
            const fontFamily = computedStyles.fontFamily;
            const lineHeight = parseInt(computedStyles.lineHeight);
            const longestWord = words.reduce((a, b) => {
                const aClean = a.replace(/<[^>]*>/g, '').trim();
                const bClean = b.replace(/<[^>]*>/g, '').trim();
                return aClean.length > bClean.length ? a : b;
            });
            const cleanLongest = longestWord.replace(/<[^>]*>/g, '').trim();

            item.style.position = 'relative';
            item.innerHTML = '';

            const monumentalWord = document.createElement('span');
            monumentalWord.classList.add('text-animation-monumental-word');
            monumentalWord.innerHTML = longestWord.trim();
            monumentalWord.style.cssText = `
                display: inline-block;
                white-space: nowrap;
                position: relative;
                transition: opacity 0.5s;
                opacity: 0;
                visibility: hidden;
                width: ${getWordWidth(cleanLongest, fontSize, fontFamily) + 40}px;
            `;
            item.appendChild(monumentalWord);

            const wordsWrapper = document.createElement('span');
            wordsWrapper.style.cssText = `
                overflow: hidden;
                display: inline-block;
                width: 100%;
                position: absolute;
                left: 0;
                right: 0;
                height: ${lineHeight}px;
            `;
            wordsWrapper.classList.add('text-animation-words-wrapper');
            item.appendChild(wordsWrapper);

            words.forEach((word, index) => {
                const span = document.createElement('span');
                span.style.cssText = `
                    display: inline-block;
                    white-space: nowrap;
                    position: absolute;
                    left: 0;
                    transition: all 0.5s;
                    transform: ${index > 0 ? 'translateY(-' + transformY + '%)' : ''};
                `;
                span.innerHTML = word.trim();
                span.classList.add('text-animation-words-wrapper-item');
                wordsWrapper.appendChild(span);
            });

            function adjustHeight() {
                let lh = parseInt(getComputedStyle(item).lineHeight);

                // lineHeight can be 'normal' or another keyword — parseInt returns NaN.
                // Fall back to fontSize * 1.3 (standard browser 'normal' approximation).
                if (isNaN(lh) || lh < 10) {
                    lh = Math.ceil(parseFloat(getComputedStyle(item).fontSize) * 1.3);
                }

                const newLineHeight = lh + 5;
                wordsWrapper.style.height = newLineHeight + 'px';
                monumentalWord.style.height = newLineHeight + 'px';

                // Also recalculate the monumental word's width from actual rendered spans,
                // so a resize (or font-load reflow) corrects the container width too.
                let maxW = 0;
                wordsWrapper.querySelectorAll('.text-animation-words-wrapper-item').forEach(span => {
                    const prev = span.style.transform;
                    span.style.transform = 'translateY(0)';
                    const w = span.getBoundingClientRect().width;
                    span.style.transform = prev;
                    if (w > maxW) maxW = w;
                });
                if (maxW > 10) {
                    monumentalWord.style.width = (maxW + 10) + 'px';
                }
            }

            adjustHeight();

            // Re-run after webfonts are loaded — font metrics change, so canvas
            // measureText() and getComputedStyle() return correct values only then.
            if (document.fonts && document.fonts.ready) {
                document.fonts.ready.then(adjustHeight);
            }

            // Only add resize listener if not already added
            if (!item.dataset.resizeListenerAdded) {
                window.addEventListener('resize', adjustHeight);
                item.dataset.resizeListenerAdded = 'true';
            }
        });
    }

    function slideDown(divs, element) {
        divs[element].style.display = 'none';
        divs[element].style.transform = 'translateY(-' + transformY + '%)';
        setTimeout(() => {
            divs[element].style.display = 'inline-block';
        }, 500);
    }

    function animateText() {
        textAnimItems.forEach(item => {
            // Prevent duplicate intervals
            if (item.dataset.animationRunning === 'true') {
                return;
            }
            item.dataset.animationRunning = 'true';

            const divs = Array.from(item.querySelectorAll('.text-animation-words-wrapper-item'));
            let index = 0;

            const intervalId = setInterval(() => {
                const nextIndex = (index + 1) % divs.length;

                divs[index].style.transform = 'translateY(+' + transformY + '%)';

                setTimeout(() => {
                    divs[nextIndex].style.transform = 'translateY(0)';
                    if (nextIndex > 0) {
                        slideDown(divs, nextIndex - 1);
                    }
                }, 500);

                if (index === 0) {
                    slideDown(divs, divs.length - 1);
                }

                index = nextIndex;
            }, 2000);

            // Store interval ID for potential cleanup
            item.dataset.intervalId = intervalId;
        });
    }

    populateText();
    animateText();
}

export { animateWord };
